export default "__VITE_ASSET__DcFwGtxI__"